module.exports = __webpack_public_path__ + "static/img/hotRanking.ce674c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rank/hotRanking.png
// module id = DtpK
// module chunks = 0